import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import styles from './Footer.module.css';

const Footer = () => {
  // Fonction pour scroller en douceur
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; // Offset pour la navbar sticky
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
  };

  return (
    <footer className={styles.footer}>
      <div className={styles['footer-container']}>
        <div className={styles.brand}>
          <p className={styles['footer-copyright']}>
            © {new Date().getFullYear()} PortaLink - Tous droits réservés
          </p>
        </div>

        <nav className={styles['footer-links']}>
          {/* Ramène en haut de la page d'accueil */}
          <Link to="/#hero" smooth scroll={scrollWithOffset} className={styles['footer-link']}>
            Accueil
          </Link>
          
          {/* Ramène à la section fonctionnalités */}
          <Link to="/#features" smooth scroll={scrollWithOffset} className={styles['footer-link']}>
            Fonctionnalités
          </Link>
          
          {/* Ramène à la section contact */}
          <Link to="/#contact" smooth scroll={scrollWithOffset} className={styles['footer-link']}>
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;